$(function() {
  var trigger = $('.tabTrigger')
  
  trigger.on('click',function() {
    if($(this).hasClass('active') === true) return false;
    //タブのactiveを外す
    $(this).parents('.tabArea').find('.active').removeClass('active');
    
    //クリックしたタブにactiveを付ける
    $(this).addClass('active');
    
    //クリックしたタブのdata属性を取得
    var tabId = $(this).data('tab-id');
    
    //コンテンツに付いているactiveを外す
    $(this).parents('.tabArea').children('.tabContents').children('.active').removeClass('active');
    
    //クリックしたタブに対応するコンテンツにactiveを付ける
    $('#'+ tabId).addClass('active');
  })

  // モーダル
  $('.modal_trigger').magnificPopup({
    type: 'inline'
  });

  $('.modal_trigger').on('click',function() {
    return false;
  })

  //閉じるボタンでモーダルを閉じる
  $('.closeBtn').on('click',function() {
    $('#modal').magnificPopup('close');
  })

})